import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { $rqCreateApiClient } from "@/api/create"
import { $rqViewsApiClient } from "@/api/groups"
import { query } from "@/api/query"
import { getXOrganizationHeaders } from "@/api/utils"
import { sketchbookRoot } from "@/constants/sketches"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/sketches/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowMinor: true })
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query(query.space.members(space)).catch(noop)

    // Sketch queries
    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/sketches", {
          params: { header: getXOrganizationHeaders(space) }
        })
      )
      .catch(noop)

    // Sketch VFS
    queryClient
      .query(
        $rqCreateApiClient.queryOptions("get", "/create/v2/files/d/{path}", {
          params: {
            header: getXOrganizationHeaders(space),
            path: { path: sketchbookRoot },
            query: { deep: true }
          }
        })
      )
      .catch(noop)

    // Additional queries
    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/things", {
          params: { header: getXOrganizationHeaders(space) }
        })
      )
      .catch(noop)

    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/devices", {
          params: { header: getXOrganizationHeaders(space) }
        })
      )
      .catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Sketches | Arduino Cloud"
      }
    ]
  })
})
